document.addEventListener("DOMContentLoaded", function () {
  const variantSelectors = document.querySelectorAll("[data-variant-input]");

  variantSelectors.forEach((input) => {
    input.addEventListener("change", function () {
      const selectedValue = this.value;
      const variantLabel = this.closest(".variant-wrapper").querySelector("[data-variant-color-label]");

      if (variantLabel) {
        variantLabel.textContent = selectedValue;
      }
    });
  });
});



